let version = 0;
const listeners = new Set<() => void>();
export const getChangeVersion = (): number => version;
export const subscribeChanges = (fn: () => void): (() => void) => { listeners.add(fn); return () => { listeners.delete(fn); }; };
export const notifyChanges = (): void => { version++; for (const fn of listeners) fn(); };
